import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a028facf6558f0014718c46/dropservice/src/app/faqs/page.tsx");
